import { Fingerprint } from 'lucide-react';
import { motion } from 'framer-motion';
import lauraDesk from '../../../assets/nature.png';
import { useGameStore } from '../../../stores/gameStore';
import { playSound } from '../../../utils/soundService';

export function Cover() {
  const setLoggedIn = useGameStore((state) => state.setLoggedIn);
  const getGameTime = useGameStore((state) => state.getGameTime);
  const time = new Date(2030, 0, 30); // January 30, 2030

  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
  const dateString = dateFormatter.format(time);
  const timeString = getGameTime();

  return (
    <div className="w-screen h-screen bg-white">
      <motion.div
        className="w-full h-screen flex flex-col items-center justify-center relative overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, delay: 0.3 }}
      >
        <img
          src={lauraDesk}
          alt="Background"
          className="w-full h-full object-cover absolute inset-0"
        />

        <div className="absolute inset-0" />

        <div className="relative z-10 mt-10 h-full gap-8 ">
          <div className="text-center flex flex-col gap-8">
            <div>
              <div className="text-4xl text-gray-600 font-mono">
                {timeString}
              </div>
              <p className="text-xl text-gray-500">{dateString}</p>
            </div>
            <div className="flex flex-col items-center gap-3">
              <button
                onClick={() => {
                  playSound('login');
                  setLoggedIn(true);
                }}
                className="cursor-pointer hover:opacity-70 transition-opacity"
                aria-label="Login with fingerprint"
              >
                <Fingerprint
                  size={32}
                  className="text-gray-900"
                  strokeWidth={1.5}
                />
              </button>
              <p className="text-lg text-gray-900">trent.1766@laura.ai</p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
